<template>
  <CoreDialog
    v-model="isOpened"
    :title="dialogTitle"
    size="fullscreen"
    transition="dialog-bottom-transition"
    attach
    divider
  >
    <template #prependBtn="{ btnProps }">
      <v-btn
        v-bind="btnProps"
        @click="isOpened = false"
      >
        <span class="ui-icon-close-not-a-circle" />
      </v-btn>
    </template>

    <div
      v-for="(project, index) in projectItems"
      :key="project.name"
      :class="{ 'mt-8': index !== 0 }"
      @click="goToProject(project.url)"
    >
      <v-img
        :src="project.logo"
        height="32"
        position="left"
        contain
      />
      <span class="text-caption text-info--text">
        {{ project.description }}
      </span>
    </div>
  </CoreDialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import CoreDialog from 'src/core/CoreDialog/CoreDialog.vue'
import { translate } from 'src/layouts/core-layout/_functions/translate'

type ProjectData = {
  description: string
  logo: string
  url: string
}

const props = defineProps<{
  value: boolean
  projects: Record<string, ProjectData>
}>()

const emit = defineEmits<{(_event: 'input', _value: boolean): void
}>()

const isOpened = computed({
  get: () => props.value,
  set: (value: boolean) => emit('input', value),
})

const dialogTitle = computed(() => translate('Наши проекты'))

const projectItems = computed(() => (
  Object.entries(props.projects || {}).map(([name, data]) => ({
    name,
    ...data,
  }))
))

function goToProject(url: string) {
  if (typeof window !== 'undefined' && typeof url === 'string') {
    window.location.href = url
  }
}
</script>
